import { BrainIcon } from '@/components/icons';
import { Box, Typography } from '@mui/material';
import { ActionButtons } from '../../ActionButtons';
import { AudioControls } from '../../AudioControls';
import { AudioProgressBar } from '../../AudioProgressBar';
import { audioCardStyles } from '../../styles';

type RecordingState =
  | 'idle'
  | 'recording'
  | 'paused'
  | 'stopped'
  | 'processing';

interface StoppedStateProps {
  title: string;
  subtitle: string;
  recordingState: RecordingState;
  recordedBlob: Blob | null;
  isProcessingAudio: boolean;
  audioSrc: string;
  audioDuration: number;
  currentTime: number;
  isPlaying: boolean;
  isReady: boolean;
  audioElement: HTMLAudioElement | null;
  onCreateAINote: () => void;
  onRecordNew: () => void;
  onSeek: (time: number) => void;
  onPlayPause: () => void;
  onPlayAgain: () => void;
  allowParallelRecording?: boolean;
}

const StoppedState: React.FC<StoppedStateProps> = ({
  title,
  subtitle,
  recordingState,
  recordedBlob,
  isProcessingAudio,
  audioSrc,
  audioDuration,
  currentTime,
  isPlaying,
  isReady,
  audioElement,
  onCreateAINote,
  onRecordNew,
  onSeek,
  onPlayPause,
  onPlayAgain,
  allowParallelRecording = false,
}) => {
  return (
    <>
      <Box sx={audioCardStyles.iconContainer}>
        <BrainIcon width={22} height={22} />
      </Box>

      <Typography variant="h5" sx={audioCardStyles.title}>
        {title}
      </Typography>

      <Typography variant="body1" sx={audioCardStyles.subtitle}>
        {subtitle}
      </Typography>

      <ActionButtons
        recordingState={recordingState}
        recordedBlob={recordedBlob}
        isProcessingAudio={isProcessingAudio}
        hasRecordingBlob={!!audioSrc} // Use audioSrc as indicator of available recording
        onCreateAINote={onCreateAINote}
        onRecordNew={onRecordNew}
        allowParallelRecording={allowParallelRecording}
      />

      <AudioProgressBar
        audioSrc={audioSrc}
        isProcessingAudio={isProcessingAudio}
        isReady={isReady}
        audioDuration={audioDuration}
        currentTime={currentTime}
        isPlaying={isPlaying}
        onSeek={onSeek}
      />

      <AudioControls
        isProcessingAudio={isProcessingAudio}
        isPlaying={isPlaying}
        currentTime={currentTime}
        audioElement={audioElement}
        onPlayPause={onPlayPause}
        onPlayAgain={onPlayAgain}
      />
    </>
  );
};

export { StoppedState };
